import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class SupAssGatherDetailService extends BaseService{
  constructor(http:HttpClient) {
    super(http);
  }

  getUrl(): string {
    return 'api/sup-ass-gather-detail';
  }
}
